import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'

import Shelf from './Shelf'

import type { ShelfProps } from './Shelf'

function MarkedShelf({ shelf, fill, ...props }: ShelfProps) {
  const { highlightedShelves, selectedShelfId, setSelectedShelfId } = useStoreMapContext()

  const isSelected = shelf.id === selectedShelfId
  const isHighlighted = highlightedShelves.includes(shelf.id)

  const fillColor = isSelected ? 'var(--color-shelf-selected)' :
    isHighlighted ? 'var(--color-shelf-highlighted)' :
      fill

  const state = isSelected ? 'selected' :
    isHighlighted ? 'highlighted' :
      undefined

  const myClickHandler = props.onShelfClick ?? setSelectedShelfId

  return <Shelf shelf={shelf} fill={fillColor} stroke={fillColor} state={state} {...props} onShelfClick={myClickHandler} />
}

export default MarkedShelf